export type ApprovalResult = {
  SUC: string;
  RQ01: string;
  RQ02: string;
  RQ03: string;
  RQ04: string;
  RQ05: string;
  RQ06: string;
  RQ07: string;
  RQ08: string;
  RQ09: string;
  RQ10: string;
  RQ11: string;
  RQ12: string;
  RQ13: string;
  RQ14: string;
  RQ15: string;
  RQ16: string;
  RQ17: string;
  RS01: string;
  RS02: string;
  RS03: string;
  RS04: string;
  RS05: string;
  RS06: string;
  RS07: string;
  RS08: string;
  RS09: string;
  RS10: string;
  RS11: string;
  RS12: string;
  RS13: string;
  RS14: string;
  RS15: string;
  RS16: string;
  RS17: string;
  RS18: string;
  RS19: string;
  RS20: string;
  RS21: string;
  RS22: string;
  RS23: string;
  RS24: string;
  RS25: string;
  RS26: string;
  RS27: string;
  RS28: string;
  RS29: string;
  RS30: string;
  RS31: string;
  RS32: string;
  RS33: string;
  RS34: string;
};

export type ErrorMessage = Record<string, string>;

export const errorMessages: ErrorMessage = {
  PRINT_PAPER_NOT_EXIST: "프린트 용지가 없습니다. 데스크 호출 바랍니다.",
  APPROVAL_REQUEST_FATAL_ERROR: "결제 진행 중 알 수 없는 오류가 발생했습니다.",
  APPROVAL_REQUEST_ERROR: "결제 요청 중 알 수 없는 오류가 발생했습니다.",
  APPROVAL_RESPONSE_STATUS_ERROR: "결제 응답 중 알 수 없는 오류가 발생했습니다.",
  APPROVAL_TRANSACTION_EXIST_ERROR: "이미 진행 된 결제 건입니다.",
  PRINT_NOT_READY: "프린터기가 연결 되지 않았습니다."
};


